var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBirthday = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.783 2.375a.25.25 0 0 1 .433 0l.433.75a.25.25 0 0 1-.216.375h-.866a.25.25 0 0 1-.217-.375l.433-.75zM5.5 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm3-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm2 .5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.75 5a.75.75 0 0 0-1.5 0v2.25H4A1.75 1.75 0 0 0 2.25 9v3.5h-.5a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5h-.5V9A1.75 1.75 0 0 0 12 7.25h-.25V5a.75.75 0 0 0-1.5 0v2.25h-1.5V5a.75.75 0 0 0-1.5 0v2.25h-1.5V5zM4 8.75a.25.25 0 0 0-.25.25v3.5h8.5V9a.25.25 0 0 0-.25-.25H4z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.216 2.375a.25.25 0 0 0-.433 0l-.433.75a.25.25 0 0 0 .217.375h.866a.25.25 0 0 0 .216-.375l-.433-.75zm2.567 0a.25.25 0 0 1 .433 0l.433.75a.25.25 0 0 1-.216.375h-.866a.25.25 0 0 1-.217-.375l.433-.75z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBirthday);
export default ForwardRef;